/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const VolunteerLanguage = {

	delete (context, id, onSuccess, onError, options) {
		Api.delete(context,
			"/volunteer-language"
			+ "?id=" + id
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getRegistrationLanguages (context, onSuccess, onError, options) {
		Api.get(context,
			"/volunteer-language/registration-languages"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, volunteerLanguageDictionaryDTO, onSuccess, onError, options) {
		Api.post(context,
			"/volunteer-language"
			, volunteerLanguageDictionaryDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, volunteerLanguageDictionaryDTO, onSuccess, onError, options) {
		Api.put(context,
			"/volunteer-language"
			, volunteerLanguageDictionaryDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
